import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import api from '@/lib/api';
import { PantallaCargando } from '@/components/Cargando';
import { tenantHasVertical } from '@/lib/verticalAccess';

/**
 * Bloquea rutas de operación vertical si el tenant no opera ese giro.
 * allow: string | string[]  (ej. 'restaurant' o ['real_estate'])
 */
export default function VerticalRouteGuard({ allow, children, fallback = '/tenant/business/resumen' }) {
  const [dict, setDict] = useState(undefined);

  useEffect(() => {
    let cancelled = false;
    api.get('/tenant/business/dictionary')
      .then((r) => { if (!cancelled) setDict(r.data || {}); })
      .catch(() => { if (!cancelled) setDict({}); });
    return () => { cancelled = true; };
  }, []);

  if (dict === undefined) return <PantallaCargando />;
  if (!tenantHasVertical(dict, allow)) {
    return <Navigate to={fallback} replace />;
  }
  return children;
}
